import Typography from '@shared/constants/Typography';
import { StyleSheet } from 'react-native';

export const createProfileStyles = (theme: any) =>
  StyleSheet.create({
    avatar: {
      justifyContent: Typography.textAlign.centerAlign,
      alignItems: Typography.textAlign.centerAlign,
    },
    dropdownAvatar: {
      justifyContent: Typography.textAlign.centerAlign,
      alignItems: Typography.textAlign.centerAlign,
      width: Typography.width.width40,
      height: Typography.height.height40,
      borderRadius: Typography.radius.fullRound,
      backgroundColor: theme.BGColor,
    },
    text: {
      color: theme.textColor,
      fontSize: Typography.fontSize.fontSize12,
      fontWeight: Typography.fontWeight.semiBold,
      fontFamily: Typography.fontFamily.inter,
    },
    onlineDot: {
      backgroundColor: theme.online,
      position: 'absolute',
      width: Typography.width.width12,
      height: Typography.height.height12,
      borderRadius: Typography.radius.fullRound,
      right: 1,
      bottom: 0,
      borderWidth: 2,
      borderColor: theme.background,
    },
    innerContainer: {
      gap: Typography.gap.gap12,
    },
    profileContainer: {
      width: Typography.width.width40,
      height: Typography.height.height40,
      borderRadius: Typography.radius.fullRound,
      backgroundColor: theme.BGColor,
      justifyContent: Typography.textAlign.centerAlign,
    },
    imageContainer: {
      width: Typography.width.width40,
      height: Typography.height.height40,
      borderRadius: Typography.radius.fullRound,
    },
    modalOverlay: {
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
    },
    dropdownMenu: {
      position: 'absolute',
      backgroundColor: theme.dropdownBG,
      borderColor: theme.dropdownBorder,
      borderRadius: Typography.radius.radius10,
      borderWidth: Typography.borderWidth.borderWidth1,
      shadowColor: theme.dropdownShadow,
      shadowOffset: { width: 0, height: Typography.height.height4 },
      shadowOpacity: 0.25,
      shadowRadius: 8,
      elevation: 8,
      gap: Typography.gap.gap8,
    },
    profileSubContainer: {
      flexDirection: 'column',
      paddingHorizontal: Typography.padding.padding16,
      paddingVertical: Typography.padding.padding12,
      gap: Typography.gap.gap12,
    },
    profileSubInnerContainer: {
      flexDirection: 'column',
      gap: Typography.gap.gap2,
    },
    profileSubChildContainer: {
      flexDirection: 'row',
      gap: Typography.gap.gap12,
    },
    dropdownUserName: {
      color: theme.dropdownUserName,
      fontSize: Typography.fontSize.fontSize14,
      fontWeight: Typography.fontWeight.bold,
      fontFamily: Typography.fontFamily.inter,
      lineHeight: Typography.lineHeight.lineHeight20,
    },
    dropdownUserId: {
      color: theme.dropdownUserId,
      fontSize: Typography.fontSize.fontSize12,
      fontWeight: Typography.fontWeight.semiBold,
      fontFamily: Typography.fontFamily.inter,
      lineHeight: Typography.lineHeight.lineHeight16,
    },
    onLine: {
      flexDirection: 'row',
      gap: Typography.gap.gap4,
      alignItems: Typography.textAlign.centerAlign,
    },
    onlineText: {
      color: theme.online,
      fontSize: Typography.fontSize.fontSize10,
      fontWeight: Typography.fontWeight.semiBold,
      fontFamily: Typography.fontFamily.inter,
      lineHeight: Typography.lineHeight.lineHeight16,
    },
    offlineText: {
      color: theme.offline,
      fontSize: Typography.fontSize.fontSize10,
      fontWeight: Typography.fontWeight.semiBold,
      fontFamily: Typography.fontFamily.inter,
      lineHeight: Typography.lineHeight.lineHeight16,
    },
    menuItem: {
      paddingHorizontal: Typography.padding.padding16,
      paddingVertical: Typography.padding.padding12,
      gap: Typography.gap.gap12,
      flexDirection: 'column',
    },
    menuSubItem: {
      flexDirection: 'row',
      gap: Typography.gap.gap12,
    },
    menuItemText: {
      color: theme.dropdownValues,
      fontFamily: Typography.fontFamily.inter,
      fontSize: Typography.fontSize.fontSize14,
      fontWeight: Typography.fontWeight.medium,
    },
    arrowIcon: {
      color: theme.workOrderIcon,
    },
    activeItem: {
      backgroundColor: theme.selectedDropdownBGColor,
      borderColor: theme.selectedDropdownBorderColor,
      borderRadius: Typography.radius.radius4,
      borderWidth: Typography.borderWidth.borderWidth1,
    },
    activeItemText: {
      color: theme.selectedDropdownTextColor,
    },
    separatorLine: {
      height: Typography.height.height1,
      backgroundColor: theme.dropdownSeparator,
    },
    logOut: {
      paddingHorizontal: Typography.padding.padding16,
      paddingVertical: Typography.padding.padding12,
      flexDirection: 'row',
      gap: Typography.gap.gap12,
    },
    logOutText: {
      color: theme.logout,
      fontFamily: Typography.fontFamily.inter,
      fontSize: Typography.fontSize.fontSize14,
      fontWeight: Typography.fontWeight.medium,
    },

    // ── Theme colour picker ────────────────────────────────────────────
    themePickerContainer: {
      paddingHorizontal: Typography.padding.padding16,
      paddingVertical: Typography.padding.padding12,
      gap: Typography.gap.gap8,
      flexDirection: 'row',
      alignItems: 'center',
    },
    themePickerLabel: {
      color: theme.dropdownValues,
      fontFamily: Typography.fontFamily.inter,
      fontSize: Typography.fontSize.fontSize12,
      fontWeight: Typography.fontWeight.semiBold,
    },
    themeSwatchRow: {
      flexDirection: 'row',
      gap: Typography.gap.gap8,
    },
    themeSwatch: {
      width: 24,
      height: 24,
      borderRadius: 12,
      borderWidth: 2,
      borderColor: 'transparent',
    },
    themeSwatchActive: {
      borderColor: theme.dropdownBorder,
      transform: [{scale: 1.2}],
    },
  });
